<template>
    <tr>
        <td colspan="8" class="layout-search">
            <label>
                <input ref="search" placeholder='Search (Press "/" to focus)' v-model="searchValue"
                       @keyup.enter="actionSearch" @focusout="actionSearch"/>
                <text-button v-if="showClear" label="clear" class="small" @click="actionClear"/>
            </label>
        </td>
    </tr>
</template>

<script>
    import {mapMutations} from "vuex";
    import TextButton from "../components/TextButton";

    export default {
        name: "LayoutSearch",
        components: {TextButton},
        computed: {
            showClear() {
                return this.searchValue.length > 0;
            }
        },
        data() {
            return {
                searchValue: '',
            }
        },
        methods: {
            actionSearch() {
                this.setSearchValue(this.searchValue);
            },
            actionClear() {
                this.searchValue = '';
                this.actionSearch();
            },
            clickKey(e) {
                if (e.keyCode === 47) {
                    setTimeout(() => {
                        this.$refs.search.focus();
                    }, 10);
                }
            },
            ...mapMutations('app', {
                setSearchValue: 'setSearchValue',
            })
        },
        created() {
            window.addEventListener('keypress', this.clickKey);
        },
    }
</script>